<div class="ficha-cadastro-veiculo-proprio">
  <form [formGroup]="form">
    <div
      class="row form-group pb0 ficha-cadastro-veiculo-proprio_title">
      <span>Informações dos Caminhões Próprios</span>
    </div>
    <div class="row">
      <div class="form-group">
        <span class="icon pesado-multi"></span>
        <div class="inputs field-group">
          <span class="ficha-cadastro-veiculo-proprio_label">Primeiro Caminhão em nome?</span>
          <div class="switch-row field-group__pesados">
            <div class="switch-group">
              <app-switch
                #simPossuiCaminhaoEmSeuNome
                id="simPossuiCaminhaoEmSeuNome"
                (change)="setPossuiCaminhaoEmSeuNome($event)">
              </app-switch>
              <span class="radio-label">Sim</span>
            </div>

            <div class="switch-group switch-field">
              <app-switch
                #naoPossuiCaminhaoEmSeuNome
                id="naoPossuiCaminhaoEmSeuNome"
                (change)="setPossuiCaminhaoEmSeuNome($event)">
              </app-switch>
              <span class="radio-label">Não</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{'dn': possuiCaminhaoEmSeuNome}">
      <div class="row">
        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label
              for="quantidade">
              Possui quantos caminhões em seu nome?
            </label>
            <input
              type="text"
              class="form-control"
              id="quantidade"
              inputmode="numeric"
              appOnlyNumberRestrictive
              placeholder="Digite a quantidade aqui..."
              formControlName="quantidadeCaminhao"
              requiredMessage="A quantidade não pode ser menor do que o total de caminhões cadastrados"
              maxlength="2"
              appShowErrorMessages>

            <div class="ficha-cadastro-veiculo-proprio_subtitle">
              <span>Cadastre ao menos 1 caminhão próprio do cliente:
                <span class="red">(máximo de 3 caminhões)</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <app-ficha-cadastro-veiculo-proprio-lista
    [hidden]="possuiCaminhaoEmSeuNome || (!quantidadeCaminhao && !hasAllVeiculoSave)"
    [veiculos]="veiculos"
    (salvar)="saveVeiculo()"
    [quantidadeCaminhao]="quantidadeCaminhao">
  </app-ficha-cadastro-veiculo-proprio-lista>

  <div class="row">
    <div class="marginT30 form-group tab-buttons">

      <a
        (click)="onClickPrevious()"
        class="bt-back btn btn-border-orange pull-left">
        <i class="fa fa-arrow-left mrBt"></i> Voltar</a>

      <a
        class="bt-go btn btn-full-orange pull-right"
        [ngClass]="{'disabled': !isNextAvailable}"
        (click)="onClickNext()">Continuar
        <i class="fa fa-arrow-right mlBt"></i>
      </a>

    </div>
  </div>
</div>
